import { useMemo } from 'react';
import { Flex } from 'antd';
import { getProgressFromSections } from 'pages/EvidencePage/helpers';
import type { EvidenceProgress, EvidenceSection } from 'api/brokerCases/types';
import type { IBtlDocument } from 'api/documents/types';
import { CustomerFilesList, NextSteps } from './components/index';

export interface IOverviewPageProps {
  sections: EvidenceSection[];
  applicationFilesInternal?: IBtlDocument[];
  showBankDetailsTask?: boolean;
  isBankDetailsComplete?: boolean;
  onGoToEvidenceV2?: () => void;
  onGoToBankDetails?: () => void;
}

export const OverviewPage = ({
  sections,
  applicationFilesInternal,
  showBankDetailsTask,
  isBankDetailsComplete,
  onGoToEvidenceV2,
  onGoToBankDetails,
}: IOverviewPageProps) => {
  const progress: EvidenceProgress = useMemo(() => getProgressFromSections(sections), [sections]);

  return (
    <Flex className='w-full gap-8'>
      <CustomerFilesList documents={applicationFilesInternal} />
      <NextSteps
        progress={progress}
        showBankDetailsTask={showBankDetailsTask}
        isBankDetailsComplete={isBankDetailsComplete}
        onGoToEvidenceV2={onGoToEvidenceV2}
        onGoToBankDetails={onGoToBankDetails}
      />
    </Flex>
  );
};
